<div class="business-loan-rate-card-component">

  <!-- ZEN-818 follow-up: BL/OD rate cards replace the base-rate + uplift model with a 3-tier model. -->
  <div class="mat-h3 rate-card-section-title">Tier Rates</div>
  <div class="row">
    <div class="col-lg-4 col-md-12">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Tier 1 Rate</mat-label>
        <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formControlTier1Rate" required>
        <span class="mdi mdi-percent" matSuffix></span>
        <mat-hint>TIB ≥ 60m · EF Director ≥ 700 · Property Backed</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-12">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Tier 2 Rate</mat-label>
        <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formControlTier2Rate" required>
        <span class="mdi mdi-percent" matSuffix></span>
        <mat-hint>TIB ≥ 12m · EF Director ≥ 550 · Property Backed</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-12">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Tier 3 Rate</mat-label>
        <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formControlTier3Rate" required>
        <span class="mdi mdi-percent" matSuffix></span>
        <mat-hint>TIB ≥ 12m · EF Director ≥ 550 · Not Property Backed</mat-hint>
      </mat-form-field>
    </div>
  </div>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <min-max-rate formControlErrorsIgnore title="Loan amount" [formControl]="formControlLoanAmount"></min-max-rate>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <min-max-rate formControlErrorsIgnore title="Loan terms" [formControl]="formControlLoanTerms"></min-max-rate>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <min-max-rate formControlErrorsIgnore title="Brokerage" [formControl]="formControlBrokerage"></min-max-rate>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <div class="mat-h3 rate-card-section-title">Risk Profile</div>
  <div class="row">
    <div class="col-lg-3 col-md-12">
      <mat-form-field>
        <mat-label>Adverse on file</mat-label>
        <input [inputMask]="createTwoDecimalInputMask" matInput type="text" [formControl]="formControlAdverseOnFile" required>
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlAdverseOnFile); track errorKey) {
          <mat-error>
            @if (formControlAdverseOnFile.touched && formControlAdverseOnFile.hasError(errorKey)) {
              {{errorMessage(formControlAdverseOnFile, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <mat-divider class="separator-bottom" [inset]="true"></mat-divider>

  <min-max-rate formControlErrorsIgnore title="Doc fee" [type]="'currency'" [formControl]="formControlDocFee"></min-max-rate>

</div>
